import defaults from './defaults';
import { Substrate } from './types';

export function getTransparentSubstrate(): Substrate {
    return {
        ...defaults,
        fullyTransparent: true,
    };
}
